import React, { useContext, useState } from "react";
import logo from "../assets/images/logo.webp";
import darkLogo from "../assets/images/dark logo.webp";
import icon from "../assets/images/icons/right icon.webp";
import darkIcon from "../assets/images/icons/dark right icon.webp";
import "../App.scss";
import { TopNav, Button } from "../styles/styles";
import { Link } from "react-router-dom";
import AppContext from "../context/context";
import curly from "../assets/images/wavy line.webp";

function TopBar() {
  const {
    navDark,
    navActive,
    handleMenu,
    hamburger,
    menu,
    handleClick,
    topOn,
  } = useContext(AppContext);
  const [hover, setHover] = useState("");
  const handleHover = (e: any) => {
    setHover(e.target.id);
  };
  const handleHoverOff = () => {
    setHover("");
  };

  return (
    <TopNav
      className={`${menu ? "menu-active" : navDark ? "top-active" : ""}`}
      style={{ display: topOn ? "none" : "" }}
    >
      <Link to="/">
        {menu ? (
          <img src={logo} alt="logo" />
        ) : navDark ? (
          <img src={darkLogo} alt="logo" />
        ) : (
          <img src={logo} alt="logo" />
        )}
      </Link>
      <div
        className={`hamburger ${hamburger ? "active" : ""}`}
        onClick={handleMenu}
      >
        <span
          className={`${menu ? "line1" : navDark ? "line1 active" : "line1"}`}
        ></span>
        <span
          className={`${menu ? "line2" : navDark ? "line2 active" : "line2"}`}
        ></span>
        <span
          className={`${menu ? "line3" : navDark ? "line3 active" : "line3"}`}
        ></span>
      </div>
      <div className="nav">
        <Link
          id="home"
          to="/"
          className={`${navActive === "home" ? "active" : ""}`}
          onClick={handleClick}
          onMouseOver={handleHover}
          onMouseOut={handleHoverOff}
        >
          Home
          {hover === "home" && navActive !== "home" && (
            <div className="curler">
              <div className="curl-holder">
                <img src={curly} alt="curly" className="rev-img" />
                <img src={curly} alt="curly rev" />
              </div>
            </div>
          )}
        </Link>
        <a
          href="#flex-section"
          id="project"
          onMouseOver={handleHover}
          onMouseOut={handleHoverOff}
        >
          Projects{" "}
          {hover === "project" && navActive !== "about" && (
            <div className="curler">
              <div className="curl-holder" style={{ width: "56px" }}>
                <img src={curly} alt="curly" className="rev-img" />
                <img src={curly} alt="curly rev" />
              </div>
            </div>
          )}
        </a>
        <Link
          to="/about"
          id="about"
          onClick={handleClick}
          onMouseOver={handleHover}
          onMouseOut={handleHoverOff}
          className={`${navActive === "about" ? "active" : ""}`}
        >
          About
          {hover === "about" && navActive !== "about" && (
            <div className="curler">
              <div className="curl-holder">
                <img src={curly} alt="curly" className="rev-img" />
                <img src={curly} alt="curly rev" />
              </div>
            </div>
          )}
        </Link>
        <Button className="dark">
          <a
            href="mailto:contact@abrahamkolade.com"
            className="p"
            target="_blank"
            rel="noreferrer noopener"
          >
            Let's Talk
          </a>
          {navDark ? (
            <img src={darkIcon} alt="icon" />
          ) : (
            <img src={icon} alt="icon" />
          )}
        </Button>
      </div>
    </TopNav>
  );
}

export default TopBar;
